// extracted by mini-css-extract-plugin
export var calculator = "calculator-module--calculator--a8640";
export var title = "calculator-module--title--17594";